import { PropsWithChildren } from 'react'
import { Row } from '@tanstack/react-table'
import clsx from 'clsx'

import styles from './Table.module.scss'

interface Props<T> extends PropsWithChildren, React.HTMLAttributes<HTMLTableRowElement> {
    className?: string
    row?: Row<T>
    setIsCreateFormActive?: (value: boolean) => void
    isUrgent?: boolean
    isLocked?: boolean
    onShiftClick?: (event: React.MouseEvent<HTMLTableRowElement>, row: Row<T>) => void
    ref?: React.RefObject<HTMLTableRowElement>
}

export const TableRow = <T,>({
    children,
    className,
    row,
    isUrgent,
    isLocked,
    setIsCreateFormActive,
    onShiftClick,
    ref,
    ...rest
}: Props<T>) => {
    return (
        <>
            <tr
                ref={ref}
                onClick={(event) => {
                    if (event.shiftKey && onShiftClick && row) {
                        onShiftClick(event, row)
                    } else {
                        row?.getToggleSelectedHandler()?.(event)
                    }
                }}
                onClickCapture={() => setIsCreateFormActive?.(false)}
                className={clsx(styles.row, className)}
                data-click-outside-exclude
                data-urgent={isUrgent}
                data-locked={isLocked}
                {...rest}
            >
                {children}
            </tr>
            <tr className={styles.rowSeparator} />
        </>
    )
}
